// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner{display:block;position:absolute;left:50%;top:50%;border-radius:50%;border-top:4px solid #00ff7f;width:80px;height:80px;opacity:0;-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite;transition:opacity .2s;pointer-events:none;transform-origin:0 0;z-index:5}", ""]);
// Exports
module.exports = exports;
